import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { HOME } from "@/constants/testIds";
import { Button } from "@/components/ui/button";
import { LogOut, Film, LayoutDashboard, LogIn, Zap, ShieldCheck } from "lucide-react";

export default function Header() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        if (!user) {
            setIsAdmin(false);
            return;
        }
        api.get("/admin/me").then(() => setIsAdmin(true)).catch(() => setIsAdmin(false));
    }, [user]);

    const onLogout = async () => {
        await logout();
        navigate("/");
    };

    return (
        <header className="sticky top-0 z-40 border-b border-white/10 bg-[#0A0A0A]">
            <div className="mx-auto flex h-16 w-full max-w-[1400px] items-center justify-between px-6">
                <Link to="/" className="flex items-center gap-2">
                    <span className="h-2 w-2 bg-[#FF2E2E]" />
                    <span className="font-display text-2xl tracking-tight text-white">
                        EARNIT
                    </span>
                    <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">
                        / le mérite avant la hype
                    </span>
                </Link>
                <nav className="flex items-center gap-2">
                    <Link
                        to="/feed"
                        data-testid={HOME.exploreFeed}
                        className="hidden items-center gap-2 border border-white/10 px-3 py-2 text-xs uppercase tracking-widest text-white transition-colors hover:border-[#FF2E2E] md:inline-flex"
                    >
                        <Film className="h-4 w-4" /> Fil de Progression
                    </Link>
                    {user?.role === "coach" && (
                        <Link
                            to="/dashboard"
                            data-testid={HOME.openDashboard}
                            className="inline-flex items-center gap-2 border border-white/10 px-3 py-2 text-xs uppercase tracking-widest text-white transition-colors hover:border-[#FF2E2E]"
                        >
                            <LayoutDashboard className="h-4 w-4" /> Espace coach
                        </Link>
                    )}
                    {isAdmin && (
                        <Link
                            to="/admin"
                            data-testid="nav-admin"
                            className="inline-flex items-center gap-2 border border-[#FF2E2E] px-3 py-2 text-xs uppercase tracking-widest text-[#FF2E2E] transition-colors hover:bg-[#FF2E2E] hover:text-white"
                        >
                            <ShieldCheck className="h-4 w-4" /> Admin
                        </Link>
                    )}
                    {user ? (
                        <>
                            <span className="hidden font-mono text-xs text-neutral-500 md:inline">
                                {user.email}
                            </span>
                            <Button
                                data-testid={HOME.logoutBtn}
                                onClick={onLogout}
                                variant="ghost"
                                className="h-9 rounded-none border border-white/10 bg-transparent px-3 text-xs uppercase tracking-widest text-white hover:border-[#FF2E2E] hover:bg-transparent"
                            >
                                <LogOut className="mr-2 h-4 w-4" /> Déconnexion
                            </Button>
                        </>
                    ) : (
                        <>
                            <Link to="/devenir-coach" data-testid="nav-coach-cta">
                                <Button
                                    variant="ghost"
                                    className="hidden h-9 rounded-none border border-[#FF2E2E] bg-transparent px-3 text-xs uppercase tracking-widest text-[#FF2E2E] hover:bg-[#FF2E2E] hover:text-white md:inline-flex"
                                >
                                    <Zap className="mr-2 h-4 w-4" /> Vous êtes coach ? Rejoignez EarnIt
                                </Button>
                            </Link>
                            <Link to="/login">
                                <Button
                                    data-testid={HOME.loginBtn}
                                    className="h-9 rounded-none bg-[#FF2E2E] px-4 text-xs uppercase tracking-widest text-white hover:bg-[#D61F1F]"
                                >
                                    <LogIn className="mr-2 h-4 w-4" /> Se connecter
                                </Button>
                            </Link>
                        </>
                    )}
                </nav>
            </div>
        </header>
    );
}
